import { render, staticRenderFns } from "./JournalistsList.vue?vue&type=template&id=d9e9e126&"
import script from "./JournalistsList.vue?vue&type=script&lang=js&"
export * from "./JournalistsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports